import { Dashboard, Metrics } from '@/components';

export const MetricsPage = (): JSX.Element => (
  <Dashboard>
    <Metrics />
  </Dashboard>
);
